export default __webpack_public_path__ + "static/media/profile-user.ed118188.svg";